import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Table } from "react-bootstrap";
import { CustomTablePagination } from "../../Components/Pagination/CustomTablePagination";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../Store/hooks";
import { showLoader } from "../../Store/loaderSlice";
import { GetApiMethod } from "../../Utils/ApiService";
import { showToaster } from "../../Store/toastSlice";

interface PlayerListDto {
  records: any[];
  totalCount: number;
}

const RejectedPlayer = ({
  selectedPlayer,
  selectedRejectedBy,
  startDate,
  endDate,
}: any) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rejectedPlayers, setRejectedPlayers] = useState<PlayerListDto>({
    records: [],
    totalCount: 0,
  });

  const dispatch = useAppDispatch();

  const fetchRejectedPlayers = useCallback(async () => {
    try {
      dispatch(showLoader({ showLoader: true }));
      const params: any = {
        page: (page + 1).toString(),
        limit: rowsPerPage.toString(),
      };

      if (selectedPlayer) params.playerId = selectedPlayer.value;
      if (selectedRejectedBy) params.rejectedById = selectedRejectedBy.value;

      // Date filter enabled
      if (startDate && endDate) {
        params.startDate = startDate.startOf("day").toISOString();
        params.endDate = endDate.endOf("day").toISOString();
      }

      const queryParams = new URLSearchParams(params).toString();
      const response = await GetApiMethod(
        "user/player-rejections?" + queryParams
      );
      setRejectedPlayers({
        records: response.data.data.records,
        totalCount: response.data.data.totalCount,
      });
      dispatch(showLoader({ showLoader: false }));
    } catch (error) {
      const errorMessages =
        (error as any)?.response?.data?.errors
          ?.map((err: any) => err.msg)
          .join(", ") || "An error occurred";

      dispatch(
        showToaster({
          dialogBgColor: "bg-danger",
          dialogMsg: errorMessages,
          showDialog: true,
          timer: "5000",
        })
      );
      dispatch(showLoader({ showLoader: false }));
    }
  }, [
    dispatch,
    page,
    rowsPerPage,
    selectedPlayer,
    selectedRejectedBy,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    fetchRejectedPlayers();
  }, [fetchRejectedPlayers]);

  return (
    <>
      <TableContainer className="mt-2">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User Name</TableCell>
              <TableCell>Rejected By</TableCell>
              <TableCell>Rejected At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rejectedPlayers.records.map((player: any) => (
              <TableRow key={player.id}>
                <TableCell>
                  {player.player?.firstName} {player.player?.lastName}
                </TableCell>
                <TableCell>
                  {player.rejectedBy?.firstName} {player.rejectedBy?.lastName}
                </TableCell>
                <TableCell>
                  {new Date(player.createdAt).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
            {rejectedPlayers.records.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No rejected players found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomTablePagination
        count={rejectedPlayers.totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(_, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
      />
    </>
  );
};

export default RejectedPlayer;
